import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CashoutBottom() {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="cashout-terms-link">
      <div className="cashout-tax-faq-link">
        <Link to="/tax-faq">{t('cashout_tax_faq')}</Link>
      </div>
      <div>
        <Link to="/terms">{t('cashout_terms_postfix')}</Link>
      </div>
    </div>
  );
}
